import { css } from 'linaria';

export const oldCartContentWrapper = css`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin-bottom: 12px;
`;

export const oldCartContentTitle = css`
  &&&& {
    @media (--to-desktop) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const oldCartContentPriceWrapper = css`
  display: flex;
  align-items: center;
  height: 39px;

  @media (--to-desktop) {
    height: 32px;
  }
`;

export const oldCartContentPrice = css`
  && {
    && {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;

      @media (--to-desktop) {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
`;

export const oldCartContentValue = css`
  && {
    font-weight: 800;
    font-size: 28px;
    line-height: 33px;

    @media (--to-desktop) {
      font-size: 24px;
      line-height: 28px;
    }
  }
`;
